import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { BacktrackToFirstUnansweredQuestionRPC } from "./backtrackToFirstUnansweredQuestionRPC";

export class BacktrackToFirstUnansweredQuestionRPCClientImpl extends BacktrackToFirstUnansweredQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: BacktrackToFirstUnansweredQuestionRPC.Request): Promise<LeoRPCResult<BacktrackToFirstUnansweredQuestionRPC.Response, BacktrackToFirstUnansweredQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/BacktrackToFirstUnansweredQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      BacktrackToFirstUnansweredQuestionRPC.ResponseDTO,
      BacktrackToFirstUnansweredQuestionRPC.Errors.ErrorsDTO,
      BacktrackToFirstUnansweredQuestionRPC.Response,
      BacktrackToFirstUnansweredQuestionRPC.Errors.Errors
    >(
      response,
      "survey-respondent/BacktrackToFirstUnansweredQuestion",
      BacktrackToFirstUnansweredQuestionRPC.Response.fromDTO,
      BacktrackToFirstUnansweredQuestionRPC.Errors.fromDTO
    );
  }
}
